export default __webpack_public_path__ + "static/media/img_6.99670d4d.jpeg";